import React from "react";
import { Chip } from "@mui/material";
import { BADGE_COLORS, getBadgeStyles } from "./badgeColors";
import { TIPOS } from "../../constants";

/**
 * Badge para tipos de incidencias.
 * El tipo es un metadato categórico: cada tipo tiene un color distinto solo
 * para identificarlo visualmente (no implica estado bueno/malo).
 */
const TipoBadge = ({ tipo, label }) => {
  // Colores de TIPO distintos a los de ORIGEN para no confundir columnas.
  // Origen usa: azul, verde, ámbar, gris, rojo, teal → tipo usa índigo, púrpura, rosa.
  const getColorByTipo = (tipo) => {
    switch (tipo?.trim()) {
      case TIPOS.ART:
        return BADGE_COLORS.INDIGO; // Artículo
      case TIPOS.PED:
        return BADGE_COLORS.PURPLE; // Pedido
      case TIPOS.ALB:
        return BADGE_COLORS.PINK; // Albarán
      default:
        return BADGE_COLORS.GRAY;
    }
  };

  return (
    <Chip
      label={label || tipo?.toUpperCase()}
      size="small"
      sx={getBadgeStyles(getColorByTipo(tipo))}
    />
  );
};

export default TipoBadge;
